import { FlatFileTransform, ValidationErrorBody } from '@cumu/shared';
import { displayServerValidationError } from './forms/validation';

export interface CsvInstruction {
  csv: string;
  lowerCaseKeys: boolean;
  transform?: FlatFileTransform;
}

export async function readCsvFile(
  csv: string,
  name: string,
  form: HTMLFormElement,
  lowerCaseKeys = false,
  transform?: FlatFileTransform
): Promise<{ error: true } | { error: false; data: unknown[] }> {
  const worker = new Worker(new URL('./csv-worker.ts', import.meta.url), {
    type: 'module'
  });
  await new Promise<MessageEvent>(resolve =>
    worker.addEventListener('message', resolve, { once: true })
  );
  const instruction: CsvInstruction = { csv, lowerCaseKeys, transform };
  worker.postMessage(instruction);
  const event = await new Promise<
    MessageEvent<{ type: 'csv-error' } | { type: 'csv-data'; data: unknown[] }>
  >(resolve => worker.addEventListener('message', resolve, { once: true }));
  worker.terminate();
  if (event.data.type === 'csv-error') {
    const error: Omit<ValidationErrorBody, 'code'> = {
      type: 'validation-error',
      message: `Error opening "${name}". Ensure the file is a valid CSV file.`
    };
    displayServerValidationError(form, error);
    return { error: true };
  }
  return { error: false, data: event.data.data };
}
